const project = {
  slug: "luggage-corner-platform",
  title: "Luggage Corner - Storage Service Website",
  oneLiner: "Travel storage service with location search, pricing tiers, reviews, FAQs and pre-booking.",
  role: ["Full-stack Developer"],
  category: "Web Development",
  clientOrOrg: "Luggage Corner",
  timeframe: { start: "2025-08", status: "Shipped" },
  domain: ["TravelTech", "Marketplace"],
  tech: ["wordpress", "PHP", "JavaScript"],
  links: { live: "https://luggage.lk" },
  impact: [
    "Streamlined the booking process and improved user experience.",
    "Increased conversion rates with a clear and user-friendly interface."
  ],
  responsibilities: [
    "Designed booking form, pricing components and reviews.",
    "Integrated map search and location markers; implemented form validation."
  ],
  features: [
    "Location finder map",
    "Pricing tiers (Small/Medium/Large/Sports)",
    "How-it-works timeline",
    "Customer reviews & FAQ",
    "Pre-booking form (reserve & pay on arrival)"
  ],
  architecture: [
    "WordPress site with a custom theme",
    "PHP for backend logic and form handling",
    "JavaScript for interactive elements"
  ],
  seo: {
    title: "Luggage Corner - Storage Service Website & Booking Flow",
    description: "Built a travel storage site with map search, pricing tiers, reviews and a pre-booking form using React/Next.js."
  },
  cover: "/assets/luggage-corner/luggage-featured.png"
};

export default project;
